export const GET_COMPLIANCE_MARKET_FAILURE = 'GET_COMPLIANCE_MARKET_FAILURE';
export const GET_COMPLIANCE_MARKET_REQUEST = 'GET_COMPLIANCE_MARKET_REQUEST';
export const GET_COMPLIANCE_MARKET_SUCCESS = 'GET_COMPLIANCE_MARKET_SUCCESS';

export const GET_AVAILABLE_CARRIERS_FAILURE = 'GET_AVAILABLE_CARRIERS_FAILURE';
export const GET_AVAILABLE_CARRIERS_REQUEST = 'GET_AVAILABLE_CARRIERS_REQUEST';
export const GET_AVAILABLE_CARRIERS_SUCCESS = 'GET_AVAILABLE_CARRIERS_SUCCESS';
